import React, { useState } from 'react';

import './index.scss';

const BubbleVoiceCall = ({ URL, data, selectedConversation }) => {
  const [showDetails, setShowDetails] = useState(false);
  const { summary, userPhone, userName, alltags, tags } = data;
  const unResponsive = tags.includes('APPOINTMENT_REMINDER_UNCONFIRMED');
  const confirmed = tags.includes('APPOINTMENT_REMINDER_CONFIRMED');
  const cancelRequest = tags.includes('APPOINTMENT_REMINDER_CANCEL_REQUESTED');
  const rescheduleRequest = tags.includes('APPOINTMENT_REMINDER_RESCHEDULE_REQUESTED');
  return (
    <div className="voicecall">
      <div
        className="reminder__container">
        <div className="reminder__header">
          {(cancelRequest || rescheduleRequest) && <div>
            <span>
              Needs attention:{' '}
            </span>
            {cancelRequest ? 'Cancellation' : 'Reschedule'} request
          </div>}
          {unResponsive && <div className="unresponsive">Appointment unconfirmed</div>}
          {confirmed && <div className="confirmed">Appointment confirmed</div>}
          <span
            className="reminder__showDetails"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? 'Hide details' : 'Show details'}
          </span>
        </div>
        {showDetails && (
          <div className="reminder__details">
            {userName.trim() && <p>
              Caller name: {userName}
            </p>}
            <p>
              Caller phone: {userPhone}
            </p>
            <p>
              {summary.appointment_details.length < 2 ? 'Appointment' : 'Appointments'}: <ol>{summary.appointment_details.map((appointment, index) => <li key={index}>{appointment}</li>)}</ol>
            </p>
            <div className="message-body">
              {summary.message_body}
            </div>
            {URL &&
              <div className="audio-player">
                <audio controls>
                  <source src={URL} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>}
            {/* {selectedConversation.status === 'FINISHED' && selectedConversation.textType === 'VOICE_CALL' &&
              <div className="reminder__details_full-transcript">
                <a href={`${window.Config.API_URL}/voice_transcripts?number=${selectedConversation.userPhone}&bzId=${selectedConversation.bzId}&format=json`} target='_blank'>click here to view complete transcript</a>
              </div>
            } */}
          </div>
        )}
      </div>
    </div>
  );
};

export default BubbleVoiceCall;
